import React from "react";
import { MoonLoader } from "react-spinners";

const Spinner = () => {
    
    return (
        <span
                style={{
                position: "fixed",
                top: "60%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width : '100px',
                height : '100px',
                }}
            >
                <MoonLoader
                color="#9756F0"

                />
            
        </span>
    );
}

export default Spinner;
